// ===============================================================
// 🔥 VideoPage.js — Page de lecture vidéo EVO LIVE
// ===============================================================

import React, { useEffect, useState } from "react";
import "../styles/VideoPage.css";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { FaPlus } from "react-icons/fa";

function VideoPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [video, setVideo] = useState(null);
  const [isFollowing, setIsFollowing] = useState(false);

  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const currentUserEmail = currentUser?.email;

  // ---------------------------------------------------------------
  // 📌 Chargement vidéo
  // ---------------------------------------------------------------
  useEffect(() => {
    axios
      .get(`/api/videos/${id}`)
      .then((res) => setVideo(res.data))
      .catch((err) => console.error("❌ Erreur chargement vidéo :", err));
  }, [id]);

  // ---------------------------------------------------------------
  // 📌 Check follow
  // ---------------------------------------------------------------
  useEffect(() => {
    if (!video || !currentUserEmail || video.user_email === currentUserEmail) return;

    axios
      .get(`/api/follows/is-following/${video.user_email}`)
      .then((res) => setIsFollowing(res.data.isFollowing))
      .catch(() => {});
  }, [video, currentUserEmail]);

  const handleFollow = async () => {
    try {
      await axios.post(`/api/follows/${video.user_email}`);
      setIsFollowing(true);
    } catch {
      alert("Erreur follow");
    }
  };

  if (!video) {
    return <div className="video-page-loading">Chargement de la vidéo...</div>;
  }

  // ---------------------------------------------------------------
  // 📌 Nettoyage chemin vidéo
  // ---------------------------------------------------------------
  let cleanPath = video.file_path || "";
  cleanPath = cleanPath
    .replace(/^\/+/, "")
    .replace(/^uploads\//, "")
    .replace(/^videos\//, "");

  const videoUrl = `/uploads/videos/${cleanPath}`;

  const videoData = {
    caption: video.caption || "",
    title: video.title || "",
    pseudo: video.user_pseudo || "",
    date: video.created_at || "",
    hashtag: video.hashtag || "",
    likes: video.likes_count || 0,
    comments: video.comments_count || 0,
    shares: video.shares_count || 0,
    views: video.views_count || 0,
  };

  const isMyVideo = video.user_email === currentUserEmail;

  return (
    <div className="video-page-container">
      <div className="video-player">

        {/* 🎬 VIDEO */}
        <video
          className="video-background"
          src={videoUrl}
          controls
          autoPlay
          playsInline
        />

        {/* 🧩 OVERLAY */}
        <div className="video-overlay-content">

          {/* 🔙 TOP BAR */}
          <div className="video-top-bar">
            <i className="fas fa-arrow-left" onClick={() => navigate(-1)}></i>
          </div>

          {/* ============================================================
              🧠 INFOS + SIDEBAR
          ============================================================ */}
          <div className="video-info-and-actions">

            {/* LEFT */}
            <div className="video-info-left">
              <p className="video-caption">
                {videoData.caption}
                <span className="video-text-large">{videoData.title}</span>
              </p>

              <div className="video-profile">
                <span className="profile-handle">@{videoData.pseudo}</span>
                <span className="dot">·</span>
                <span className="date">{videoData.date}</span>
                <span className="hashtag">{videoData.hashtag}</span>
              </div>
            </div>

            {/* ============================================================
                👉 SIDEBAR DROITE (ICI TOUT SE PASSE)
            ============================================================ */}
            <div
              className="video-actions-right"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 18,
              }}
            >

              {/* 👤 PHOTO PROFIL */}
              <div style={{ position: "relative", width: 56, height: 56 }}>
                <img
                  src={
                    video.profile_picture
                      ? `/uploads/${video.profile_picture}`
                      : "/default-avatar.png"
                  }
                  alt="profil"
                  onClick={() => navigate(`/user/${videoData.pseudo}`)}
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "2px solid white",
                    cursor: "pointer",
                  }}
                />

                {/* ➕ FOLLOW */}
                {!isMyVideo && !isFollowing && (
                  <button
                    onClick={handleFollow}
                    style={{
                      position: "absolute",
                      bottom: -4,
                      right: -4,
                      width: 22,
                      height: 22,
                      borderRadius: "50%",
                      border: "none",
                      background: "red",
                      color: "white",
                      fontSize: 12,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                    <FaPlus />
                  </button>
                )}
              </div>

              {/* ❤️ */}
              <div className="action-item">
                <i className="fas fa-heart"></i>
                <span className="count">{videoData.likes}</span>
              </div>

              {/* 💬 */}
              <div className="action-item">
                <i className="fas fa-comment-dots"></i>
                <span className="count">{videoData.comments}</span>
              </div>

              {/* 👁 */}
              <div className="action-item">
                <i className="fas fa-eye"></i>
                <span className="count">{videoData.views}</span>
              </div>

              {/* 🎁 */}
              <div className="action-item">
                🎁
              </div>

              {/* ⋮ */}
              <div className="action-item">
                <i className="fas fa-ellipsis-h"></i>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VideoPage;
